import { Component, Input, OnInit } from '@angular/core';
import { NbMenuItem } from '@nebular/theme';

@Component({
  selector: 'ubs-bottom-header',
  templateUrl: './bottom-header.component.html',
  styleUrls: ['./bottom-header.component.scss']
})
export class BottomHeaderComponent implements OnInit {
  @Input() menuItems:NbMenuItem[];

  constructor() { }

  ngOnInit(): void {
  }

}
